let baseUrl = {
  LOGIN_ROOT:'',
  UPLOAD_ROOT:'',
  H5_ROOT:'',
  logOutFront: '',
  logOutBack: '',
  address: '',
  photoUrl: '',
  loginFront: '',
  loginBack: '',
  uploadImg: '',
  deleteImg: '',
  linkUrl: '',
  pageAdressUrl: '',
  getst: ''
}
// switch (process.env.ENV_CONFIG) {
//   case 'dev':
//     // 这里是本地的请求url
//     baseUrl.LOGIN_ROOT='https://testsso.ihasl.com',
//     baseUrl.UPLOAD_ROOT = 'https://testfile.ihasl.com',
//     baseUrl.H5_ROOT ='https://teststatic.ihasl.com'
//     break
//   case 'uat':
//     // 这里是测试环境中的url
//     baseUrl.LOGIN_ROOT='https://testsso.ihasl.com',
//     baseUrl.UPLOAD_ROOT = 'https://testfile.ihasl.com',
//     baseUrl.H5_ROOT ='https://teststatic.ihasl.com'

//     break
//   case 'prod':
//     // 生产环境url
//     baseUrl.LOGIN_ROOT='https://testsso.ihasl.com',
//     baseUrl.UPLOAD_ROOT = 'https://testfile.ihasl.com',
//     baseUrl.H5_ROOT ='https://teststatic.ihasl.com'
//     break
// }
baseUrl.logOutFront =process.env.LOGIN_ROOT+ '/SSO2/SSO-JTL2.html?service='
baseUrl.logOutBack = process.env.LOGIN_ROOT+'/HASLSSO2/logout?service='

baseUrl.loginFront = process.env.LOGIN_ROOT+'/HASLSSO2/login?loginUrl='
baseUrl.loginBack =process.env.LOGIN_ROOT+'/SSO2/SSO-JTL.html?service='
baseUrl.getst =process.env.LOGIN_ROOT+'/HASLSSO2/GETST?service='
baseUrl.address = '/pages/salessupport/pc/index.html#/'
baseUrl.photoUrl = 'https://file.ihasl.com/eapp2/eapp-getFile/'
baseUrl.uploadImg =process.env.FILE_ROOT+'/file/v1/hasl/fileAdmin/fileAdmin/upload'
// 删除文件服务器图片
baseUrl.deleteImg = process.env.FILE_ROOT+'/file/v1/hasl/fileAdmin/fileAdmin/expired'
baseUrl.staticUrl =process.env.H5_ROOT+ "/pages/salessupport/pc/static"

baseUrl.bigUrl =process.env.H5_ROOT+ "/pages/salessupport/lottery/#/ActivityLottery?activityId="
baseUrl.linkUrl =process.env.FILE_ROOT + '/file/v1/hasl/fileAdmin/fileAdmin/get/'
baseUrl.downloadUrl=process.env.FILE_ROOT + '/file/v1/hasl/fileAdmin/fileAdmin/download/'
baseUrl.pageAdressUrl =process.env.H5_ROOT+'/pages/salessupport/app/index.html#/detail?id='
baseUrl.testLink =process.env.H5_ROOT+'/pages/salessupport/octahedral/#/activityInvitation?activityId='

export default baseUrl



// WEBPACK FOOTER //
// ./src/assets/js/baseUrl.js